/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text, theme } from "@nordcloud/gnui";

export function Footer() {
  return (
    <div className="footer">
      <Text size="sm" color={theme.color.text.text02} align="center">
        IBM&nbsp;MULTICLOUD&nbsp;ACCELERATOR by Nordcloud Oy ©{" "}
        {new Date().getFullYear()}
      </Text>
    </div>
  );
}
